export default function Logo({
  color = "#B7974A",
  width = "239",
  className = "",
}) {
  return (
    <>
      <svg
        width={width}
        className={`${className}`}
        viewBox="0 0 803 228"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_744_6)">
          <path
            d="M157.03 200.05C164.86 200.05 170.63 206.04 170.63 213.54C170.63 221.04 164.89 227.03 157.03 227.03C149.17 227.03 143.43 221.11 143.43 213.54C143.43 205.97 149.16 200.05 157.03 200.05ZM157.03 221.94C161.72 221.94 165.04 218.19 165.04 213.53C165.04 208.87 161.72 205.13 157.03 205.13C152.34 205.13 149.02 208.92 149.02 213.53C149.02 218.14 152.34 221.94 157.03 221.94Z"
            fill={color}
          />
          <path
            d="M187.93 217.65V226.53H182.37V200.56H190.81C196.8 200.56 200.8 203.52 200.8 209.11C200.8 214.7 196.8 217.66 190.81 217.66H187.93V217.65ZM187.93 205.2V212.96H191.1C193.52 212.96 195.18 211.7 195.18 209.1C195.18 206.5 193.45 205.2 190.96 205.2H187.93Z"
            fill={color}
          />
          <path
            d="M212.04 226.52V200.55H228.74V205.2H217.59V211.12H227.04V215.59H217.59V221.87H229.28V226.52H212.04Z"
            fill={color}
          />
          <path
            d="M262.39 226.919L248.14 213.249L246.44 211.769V226.519H240.99V200.149H241.21L255.42 213.819L257.08 215.299V200.549H262.56V226.919H262.38H262.39Z"
            fill={color}
          />
          <path d="M275.94 226.52V200.55H281.5V226.52H275.94Z" fill={color} />
          <path
            d="M316.26 226.919L302.01 213.249L300.31 211.769V226.519H294.86V200.149H295.08L309.29 213.819L310.95 215.299V200.549H316.43V226.919H316.25H316.26Z"
            fill={color}
          />
          <path
            d="M342.11 227.03C333.89 227.03 328.15 221.15 328.15 213.54C328.15 205.93 333.96 200.05 342 200.05C345.86 200.05 348.67 201.13 350.15 201.82V206.94C348.45 206.15 345.86 205.14 342.36 205.14C336.98 205.14 333.74 208.93 333.74 213.54C333.74 218.15 336.99 221.98 342.11 221.98C343.37 221.98 344.74 221.77 345.65 221.48V214.55H350.95V225.05C348.64 226.24 345.29 227.03 342.11 227.03Z"
            fill={color}
          />
          <path
            d="M376.1 225.55V220.21C377.9 221.15 380.29 221.94 382.63 222.09C383.46 222.13 384.25 222.09 384.94 221.95C386.92 221.66 388.08 220.9 388.08 219.64C388.08 217.91 386.53 217.01 382.96 215.71C378.42 214.05 375.75 212.14 375.75 207.63C375.75 203.12 379.57 200.06 385.17 200.06C387.77 200.06 390.33 200.64 391.95 201.36V206.48C390.43 205.58 387.98 204.89 385.6 204.89C382.93 204.89 381.2 205.94 381.2 207.6C381.2 209.11 382.61 210.16 386.14 211.49C390.68 213.26 393.5 215.17 393.5 219.53C393.5 224.22 389.96 227.03 383.83 227.03C380.87 227.03 377.99 226.38 376.11 225.55H376.1Z"
            fill={color}
          />
          <path
            d="M416.96 200.05C424.79 200.05 430.56 206.04 430.56 213.54C430.56 221.04 424.82 227.03 416.96 227.03C409.1 227.03 403.36 221.11 403.36 213.54C403.36 205.97 409.1 200.05 416.96 200.05ZM416.96 221.94C421.65 221.94 424.97 218.19 424.97 213.53C424.97 208.87 421.65 205.13 416.96 205.13C412.27 205.13 408.95 208.92 408.95 213.53C408.95 218.14 412.27 221.94 416.96 221.94Z"
            fill={color}
          />
          <path
            d="M442.3 226.52V200.55H447.86V221.87H457.85V226.52H442.3Z"
            fill={color}
          />
          <path
            d="M490.41 217.07C490.41 223.13 486.41 227.03 479.55 227.03C472.69 227.03 468.69 223.14 468.69 217.07V200.55H474.24V216.53C474.24 219.92 476.15 221.94 479.54 221.94C482.93 221.94 484.84 219.92 484.84 216.53V200.55H490.39V217.07H490.41Z"
            fill={color}
          />
          <path
            d="M513.77 205.2V226.52H508.22V205.2H500.97V200.55H521.06V205.2H513.77Z"
            fill={color}
          />
          <path d="M531.97 226.52V200.55H537.52V226.52H531.97Z" fill={color} />
          <path
            d="M562.84 200.05C570.67 200.05 576.44 206.04 576.44 213.54C576.44 221.04 570.7 227.03 562.84 227.03C554.98 227.03 549.24 221.11 549.24 213.54C549.24 205.97 554.97 200.05 562.84 200.05ZM562.84 221.94C567.53 221.94 570.85 218.19 570.85 213.53C570.85 208.87 567.53 205.13 562.84 205.13C558.15 205.13 554.83 208.92 554.83 213.53C554.83 218.14 558.15 221.94 562.84 221.94Z"
            fill={color}
          />
          <path
            d="M609.57 226.919L595.32 213.249L593.62 211.769V226.519H588.17V200.149H588.38L602.59 213.819L604.25 215.299V200.549H609.73V226.919H609.55H609.57Z"
            fill={color}
          />
          <path
            d="M621.93 225.55V220.21C623.73 221.15 626.12 221.94 628.46 222.09C629.29 222.13 630.08 222.09 630.77 221.95C632.75 221.66 633.91 220.9 633.91 219.64C633.91 217.91 632.36 217.01 628.79 215.71C624.24 214.05 621.58 212.14 621.58 207.63C621.58 203.12 625.4 200.06 630.99 200.06C633.59 200.06 636.15 200.64 637.77 201.36V206.48C636.25 205.58 633.8 204.89 631.42 204.89C628.75 204.89 627.02 205.94 627.02 207.6C627.02 209.11 628.43 210.16 631.96 211.49C636.5 213.26 639.32 215.17 639.32 219.53C639.32 224.22 635.78 227.03 629.65 227.03C626.69 227.03 623.81 226.38 621.93 225.55Z"
            fill={color}
          />
          <path
            d="M248.2 0C240.84 0 233.76 1.52 227.18 4.24C252.24 14.66 270.26 43.12 270.26 76.66C270.26 110.2 252.24 138.66 227.18 149.06C233.76 151.8 240.84 153.3 248.2 153.3C283.6 153.3 312.3 118.98 312.3 76.66C312.3 34.34 283.6 0 248.2 0Z"
            fill={color}
          />
          <path
            d="M418.3 87.3398H419.06C446.36 87.3398 465.54 70.6598 465.54 44.5998C465.54 18.5398 446.36 1.83984 419.06 1.83984C406.9 1.83984 387.81 1.83984 389.38 1.83984C399.68 1.83984 344.36 1.83984 344.36 1.83984V151.46H389.38V87.3598L441.48 151.46H491.44L463.84 114.9C448.46 95.4798 440.26 88.2998 418.3 87.3398ZM389.38 87.1798V2.15984C406.12 5.13984 428.04 17.7598 428.04 44.5998C428.04 71.4398 406.2 84.5198 389.38 87.1798Z"
            fill={color}
          />
          <path
            d="M184.1 76.66C184.1 43.12 202.1 14.66 227.18 4.24C220.6 1.52 213.52 0 206.16 0C170.76 0 142.06 34.32 142.06 76.66C142.06 119 170.76 153.3 206.16 153.3C213.52 153.3 220.6 151.8 227.18 149.06C202.1 138.66 184.1 110.18 184.1 76.66Z"
            fill={color}
          />
          <path d="M101.94 63.4805H45.02L101.94 103.72V63.4805Z" fill={color} />
          <path d="M0 151.46H45.02V63.4798V1.83984H0V151.46Z" fill={color} />
          <path
            d="M118.88 54.0598V1.83984H45.02L118.88 54.0598Z"
            fill={color}
          />
          <path
            d="M663.68 1.83984V151.46H708.72V63.4798V1.83984H663.68Z"
            fill={color}
          />
          <path
            d="M633.18 40.3798V1.83984H585.14L633.18 40.3798Z"
            fill={color}
          />
          <path
            d="M782.56 1.83984H708.72L782.56 54.0598V1.83984Z"
            fill={color}
          />
          <path d="M782.56 106.26L708.72 151.46H782.56V106.26Z" fill={color} />
          <path
            d="M763.24 63.4805H708.72L763.24 102.02V63.4805Z"
            fill={color}
          />
          <path d="M585.14 1.83984H540.1V151.46H585.14V1.83984Z" fill={color} />
          <path
            d="M492.06 40.3798L540.1 1.83984H492.06V40.3798Z"
            fill={color}
          />
          <path
            d="M789.66 4.75992V11.1399H787.8V4.75992H785.32V3.16992H792.15V4.75992H789.66ZM800.75 11.1399V7.41992C800.75 6.45992 800.77 5.49992 800.79 4.54992H800.75C800.48 5.48992 800.24 6.42992 799.97 7.36992L798.87 11.1299H796.74L795.64 7.36992C795.37 6.42992 795.1 5.48992 794.86 4.54992H794.82C794.84 5.48992 794.86 6.44992 794.86 7.41992V11.1399H793.14V3.16992H796.03L796.99 6.49992C797.28 7.45992 797.55 8.46992 797.77 9.45992H797.81C798.03 8.46992 798.3 7.46992 798.59 6.49992L799.58 3.16992H802.47V11.1399H800.75Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_744_6">
            <rect width="802.47" height="227.03" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
